import { useState } from 'react';
import { SERVER_URL } from '../../lib/apiClient';
import { ACCENT } from './landingData';
import { track } from '../../lib/analytics';

const VT = "'VT323', monospace";

type Phase = 'idle' | 'sending' | 'done' | 'error';

/** Footer email capture — posts to the public /newsletter endpoint. */
export default function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [phase, setPhase] = useState<Phase>('idle');

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (phase === 'sending') return;
    setPhase('sending');
    try {
      const res = await fetch(`${SERVER_URL}/newsletter`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (res.ok) track('newsletter_submitted');
      setPhase(res.ok ? 'done' : 'error');
    } catch {
      setPhase('error');
    }
  }

  if (phase === 'done') {
    return (
      <p style={{ fontFamily: VT, fontSize: 17, color: ACCENT, margin: 0 }}>
        ▸ Signal received. Welcome to the bunker list.
      </p>
    );
  }

  return (
    <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <div style={{ display: 'flex', gap: 6 }}>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@domain.com"
          aria-label="Email address"
          style={{ flex: 1, minWidth: 0, background: '#070b09', border: '1px solid #2a3a2f', color: '#c4d2c8', fontFamily: VT, fontSize: 16, padding: '8px 10px', outline: 'none' }}
        />
        <button
          type="submit"
          disabled={phase === 'sending'}
          aria-label="Subscribe"
          style={{ background: ACCENT, border: `1px solid ${ACCENT}`, color: '#06110a', fontFamily: VT, fontSize: 18, padding: '0 14px', cursor: 'pointer', opacity: phase === 'sending' ? 0.6 : 1 }}
        >
          →
        </button>
      </div>
      {phase === 'error' && (
        <span style={{ fontFamily: VT, fontSize: 15, color: '#e05050' }}>
          Transmission failed — check the address and retry.
        </span>
      )}
    </form>
  );
}
